import * as Sentry from '@sentry/react';
import { T_TRIALS_EMAIL } from '@tempus/trials-types';
import React from 'react';

import { config } from '~/config';

const sentryDsn = config.sentryDsn;
const { enableSentry } = config.toggles;

interface ErrorBoundaryProps {
  children: React.ReactNode;
}

const ErrorBoundary = ({ children }: ErrorBoundaryProps) => (
  <Sentry.ErrorBoundary
    fallback={() => (
      <div
        style={{
          fontSize: 20,
          lineHeight: 1.5,
          margin: 100,
          textAlign: 'center',
        }}
      >
        <h1>
          An error has occured.
          <br />
          Please refresh your browser and try again.
          <br />
        </h1>
        Contact {T_TRIALS_EMAIL} if you continue to experience any problems.
      </div>
    )}
  >
    {children}
  </Sentry.ErrorBoundary>
);

if (enableSentry === '1' && sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    integrations: [Sentry.browserTracingIntegration()],
    environment: config.environment,
    release: 'therapies',
    tracesSampleRate: 1.0,
  });
}

export default ErrorBoundary;
